import { FileViewer } from "@/components/features/matter/file-repo/FileViewer";
import { Button, Input, Label, SheetFooter, Slideover } from "@/components/ui";

type ShareFolderFilePreviewSlideoverProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  description?: string;
  fileName: string;
  presignedUrlKey: string;
  shareFolderLabel?: string;
};

export function ShareFolderFilePreviewSlideover({
  open,
  setOpen,
  title,
  description,
  fileName,
  presignedUrlKey,
}: ShareFolderFilePreviewSlideoverProps) {
  return (
    <Slideover
      open={open}
      setOpen={setOpen}
      title="View matter share folder file"
      description={description}
      size="large"
    >
      <div className="flex h-full flex-col">
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            <div className="w-1/2 space-y-2">
              <Label>File name</Label>
              <Input value={title} disabled readOnly />
            </div>
            <FileViewer
              file={{ fileName, presignedURLKey: presignedUrlKey }}
              fileType="matter-share-folder-file"
              showTitle={false}
            />
          </div>
        </div>
        <SheetFooter addSlideoverStyles>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              setOpen(false);
            }}
          >
            Close
          </Button>
        </SheetFooter>
      </div>
    </Slideover>
  );
}
